import React, { FC, useContext } from 'react';
import { withRouter, RouteComponentProps } from 'react-router-dom';
import { StylesProvider, ThemeProvider } from '@material-ui/core';
import ReactModal from 'react-modal';
import { AuthContext } from '@ryanar/react-auth-provider';
import getRoutes from 'routes/routes';
import muiBreakpoints from 'constants/breakpoints';

const Content: FC = () => {
  const { authenticated } = useContext(AuthContext);

  return (
    <>
      {getRoutes(authenticated)}
    </>
  );
};

const App: FC<RouteComponentProps> = () => (
  <StylesProvider injectFirst>
    <ThemeProvider theme={muiBreakpoints}>
      <Content />
    </ThemeProvider>
  </StylesProvider>
);
ReactModal.setAppElement('#root');

export default withRouter(App);
